import React, { useEffect, useState } from 'react';

import { observer } from 'mobx-react';
import classNames from 'classnames';

import classes from './NgzSidebar.module.scss';
import { angularizeWithProviders } from '../../providers';
import { usePageConfig } from '../../hooks/usePageConfig';
import { SidebarNavigation } from './SidebarNavigation/SidebarNavigation';
import { SidebarSystemMenu } from './SidebarSystemMenu/SidebarSystemMenu';
import { SidebarProvider, useSidebarContext } from './hooks/SidebarContext';
import { SidebarLogoSection } from './SidebarLogoSection/SidebarLogoSection';
import { SideBarMenu } from '../../interfaces/system/SidebarNavConfig';
import { LOCAL_STORAGE_KEYS } from '../../constants/system/LOCAL_STORAGE_KEYS';
import { systemService } from '../../services/systemService';
import { loggedInUserDataStore } from '../../stores/loggedInUserDataStore';
import { getDefaultSidebarMenuConfig } from './utils/getDefaultSidebarMenuConfig';

const SidebarContent = () => {
  const [sidebarMenu, setSidebarMenu] = useState<SideBarMenu>(
    getDefaultSidebarMenuConfig(),
  );
  const { isCollapsed } = useSidebarContext();

  const getSidebarMenuConfig = async () => {
    const sidebarMenuConfig = await systemService.getSidebarMenuConfig();

    localStorage.setItem(
      LOCAL_STORAGE_KEYS.SIDEBAR_MENU,
      JSON.stringify(sidebarMenuConfig),
    );
    setSidebarMenu(sidebarMenuConfig);
  };

  useEffect(() => {
    getSidebarMenuConfig();
  }, []);

  return (
    <aside
      className={classNames(classes.sidebar, {
        [classes.collapsed]: isCollapsed,
      })}
    >
      <SidebarLogoSection />
      <SidebarNavigation items={sidebarMenu.mainNavigation} />
      <SidebarSystemMenu items={sidebarMenu.systemMenu} />
    </aside>
  );
};

const NgzSidebar = observer(() => {
  const { loggedInUser } = loggedInUserDataStore;
  const { hideNavigation } = usePageConfig();

  /* loggedInUser?.id because loggedInUser can exist when login as corporate account and need hide sidebar
   * for more info see docs/CORPORATE_ACCOUNTS.md
   */
  if (hideNavigation || !loggedInUser?.id) {
    return null;
  }

  return (
    <SidebarProvider>
      <SidebarContent />
    </SidebarProvider>
  );
});

angularizeWithProviders(NgzSidebar, 'ngzSidebar', {});

export { NgzSidebar };
